const state = {
  account: null,
  agency: null,
  branding: null,
  entityBranding: null,
  tempData: null,
  user: null,
  drilldownState: null,
}

const mutations = {
  account(state, account) {
    state.account = account
  },

  agency(state, agency) {
    state.agency = agency
  },

  branding(state, branding) {
    state.branding = branding
  },

  entityBranding(state, entityBranding) {
    state.entityBranding = entityBranding
  },

  tempData(state, tempData) {
    state.tempData = tempData
  },

  user(state, user) {
    state.user = user
  },

  drilldownState(state, newState) {
    state.drilldownState = newState;
  }
}

const actions = {
  account({ commit }, account) {
    commit('account', account)
  },

  agency({ commit }, agency) {
    commit('agency', agency)
  },

  branding({ commit }, branding) {
    commit('branding', branding)
  },

  entityBranding({ commit }, branding) {
    commit('entityBranding', branding)
  },

  tempData({ commit }, temp) {
    commit('tempData', temp)
  },

  user({ commit }, user) {
    commit('user', user)
  },

  drilldownState({ commit }, newState) {
    commit('drilldownState', newState);
  }
}

const getters = {
  account(state) {
    return state.account
  },

  agency(state) {
    return state.agency
  },

  branding(state) {
    return state.branding
  },

  entityBranding(state) {
    return state.entityBranding
  },

  tempData(state) {
    return state.tempData
  },

  user(state) {
    return state.user
  },

  drilldownState(state) {
    return state.drilldownState;
  }
}

export default {
  namespaced: true,
  mutations,
  getters,
  actions,
  state,
}
